import gql from 'graphql-tag';

const UPDATE_CONTACT_PERMISSION_QUERY = gql`
  mutation updateContactPermission($contactPermission: Boolean!, $key: String) {
    updateContactPermission(contactPermission: $contactPermission, key: $key) {
      id
      contactPermission
    }
  }
`;

export default UPDATE_CONTACT_PERMISSION_QUERY;
